import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { AppErrorBoundary } from "@/components/layout/AppErrorBoundary";
import { cleanUpPaymentStorage } from "@/lib/pendingPayment";
import "./index.css";

// A 2025-ös PWA maradéka: akinél még ott a service worker regisztráció, annak a böngészője a
// cache-ből kapná az alkalmazást. A public/sw.js azokat szereli le, akik el sem jutnak idáig;
// ez a sor azokat takarítja ki, akik már ezt a kódot futtatják (különben a következő
// navigációnál megint a régi worker döntene arról, mit lássanak).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .then((unregistered) => (unregistered.some(Boolean) ? caches.keys() : []))
    .then((cacheNames) => Promise.all(cacheNames.map((name) => caches.delete(name))))
    .catch(() => {
      // A takarítás sosem foghatja meg az indulást
    });
}

// A régebbi kliens a Teyára küldés előtt a vendég adatait (név, e-mail, telefon, cím) is a
// böngészőben hagyta, és csak a visszatéréskor törölte: egy félbehagyott fizetésé ott maradt.
// Ugyanitt megy egy félbehagyott fizetés elavult azonosítója is (`pendingPayment.ts`).
cleanUpPaymentStorage();

// Az oldalak és admin szekciók külön chunkokban töltődnek. Telepítés után a régi, még nyitva
// lévő oldal a következő navigációnál már nem létező fájlt kérne: ilyenkor egyszer újratöltünk
// (az új index.html az új fájlokra mutat). Ha ez sem segít, nem pörgünk körbe - a hibahatár
// mutatja az üzenetet.
const RELOAD_MARK = "chunk-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  const lastReload = Number(sessionStorage.getItem(RELOAD_MARK) ?? 0);
  if (Date.now() - lastReload < 10_000) return;
  event.preventDefault();
  sessionStorage.setItem(RELOAD_MARK, String(Date.now()));
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
